export default function isEmptyArray(array: any) {
  return !(Array.isArray(array) && array.length);
}
